<div [formGroup]="form">
  <label for="{{ baseId }}-text-color" translate>Text Color</label>
  <div class="input-group">
    <input
            readonly
            type="text"
            class="form-control"
            [ngStyle]="{'color': color}"
            [(ngModel)]="textColorValue"
            formControlName="textColor">
    <div class="input-group-append" (click)="showColorSelectorModal()">
      <span class="input-group-text"><i class="material-icons md-20" title="find control">search</i></span>
    </div>
  </div>
</div>
